export const CLEAR_SURVEYS = 'CLEAR_SURVEYS'

export const SET_SURVEYS = 'SET_SURVEYS'

export const SET_CLINICIAN_SURVEYS = 'SET_CLINICIAN_SURVEYS'

export const SET_OPTIONAL_SURVEYS = 'SET_OPTIONAL_SURVEYS'

export const SET_SELECTED_SURVEY = 'SET_SELECTED_SURVEY'
